//import { THIS_EXPR } from  '@angular/compiler/src/output/output_ast';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core'
import { Form, FormControl, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { CarteraService } from '../../../services/cartera/cartera.service';
import { ClienteService } from '../../../services/cliente/cliente.service';
import { ConfigService } from '../../../services/config/config.service';
import { HttpErrorResponse } from '@angular/common/http';
import { LocalizacionService } from '../../../services/localizacion/localizacion.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-abono-cartera',
  templateUrl: './abono-cartera.component.html',
  styleUrls: ['./abono-cartera.component.scss'],
  standalone: false,
  providers: [MessageService]
})
export class AbonoCarteraComponent implements OnInit {
  loadMenu: boolean = true;
  load: boolean = false;
  identificacion: number = 0;
  formAsignacion = new FormGroup({
    valorAsignado: new FormControl({ value: 0, disabled: true }, [Validators.required, Validators.pattern(/^(0|[1-9][0-9]*)$/)]),
    valorConsumido: new FormControl({ value: 0, disabled: true }, [Validators.required, Validators.pattern(/^(0|[1-9][0-9]*)$/)]),
    stateCartera: new FormControl(1, Validators.required)
  });
  token: any = {};
  resultClient: Array<any> = [];
  buscador: string = "";
  labelBtn: String = "Crear"
  @ViewChild("d") input: any;
  @ViewChild("btn") btnAbono: any;
  @ViewChild('queryFrame') frame!: ElementRef;
  idClienteSelected: number = 0;
  identificacionCliente: number = 0;
  infoUser: any = {};
  infoEmpresa: any = {};
  statesCartera: Array<any> =
    [{ idEstadoCartera: 1, Estado: 'Activo' },
    { idEstadoCartera: 2, Estado: 'En cobro' },
    { idEstadoCartera: 3, Estado: 'Cancelado en totalidad' },
    { idEstadoCartera: 4, Estado: 'Inactiva' }];
  lsCarteraUser: Array<any> = [];
  lsCarteraUserActivo: any = {};
  activeState: boolean[] = [false, false, false, false, false];
  detalleCartera: Array<any> = [];
  abonoCarteras: Array<any> = [];
  showTicket: boolean = false;
  metodoPagoIni: Array<any> = [];
  metodoPagoFilter: Array<any> = [];
  selectedMethod: any = {};
  valorAbonoCartera: number = 0;
  referencia: string = "";

  // busqueda de clientes
  displayInfoClient: boolean = true;
  formClient = new FormGroup({
    tipo: new FormControl({ idTipoIdentificacion: 0 }, Validators.required),
    identificacion: new FormControl(null, [Validators.required, Validators.pattern(/^(0|[1-9][0-9]*)$/)]),
    razonSocial: new FormControl('', Validators.required),
    nombres: new FormControl('', [Validators.required, Validators.maxLength(200)]),
    direccion: new FormControl(''),
    departamento: new FormControl(null),
    ciudad: new FormControl(null),
    correo: new FormControl('', [Validators.email, Validators.required]),
    telefono: new FormControl('', [Validators.pattern(/^(0|[1-9][0-9]*)$/)]),
  });
  listIdentificationType: Array<any> = [];
  digito: number | undefined;
  timeSearchCliente: any | undefined;
  resultsLsClients: Array<any> = [];
  selectedClient: any | undefined;
  lockedFieldsIdClient: boolean = true;
  fieldSearchClient: any | undefined;
  listDptos: Array<any> = [];
  listCities: Array<any> = [];
  citySelected: any = {};
  infoParametrizacion: any = {};


  constructor(private cliente: ClienteService,
    private message: MessageService,
    private cartera: CarteraService,
    private config: ConfigService,
    private client: ClienteService,
    private localizacion: LocalizacionService,
    private router: Router) {
  }

  ngOnInit(): void {
    this.token = JSON.parse(localStorage.getItem('token') ?? "".toString());
    this.infoUser = JSON.parse(localStorage.getItem('infoUser') ?? "[]");
    this.infoEmpresa = JSON.parse(localStorage.getItem('empresa') ?? "[]");
    this.metodoPagoIni = JSON.parse(localStorage.getItem("metodoPago") ?? "[]") as Array<any>;
    this.infoParametrizacion = JSON.parse(localStorage.getItem('parametros') ?? "");
    this.metodoPagoIni = this.metodoPagoIni.map(item => {
      return {
        "idVentaMetodoPago": item.idVentaMetodoPago,
        "label": item.metodoPago,
        "valor": 0,
        "referencia": item.idVentaMetodoPago == 1 ? "Efectivo" : ""
      }
    });
    // definiendo por defecto el metodo de pago
    this.selectedMethod =this.metodoPagoIni[0];

    if (!localStorage.getItem('identificationType'))
      // get identification types
      this.cliente.getTypeIndetification(this.token.token).subscribe({
        next: (response) => {
          this.listIdentificationType = response as Array<any>;
          // asignación de variable global
          if (this.listIdentificationType.length > 0)
            localStorage.setItem('identificationType', JSON.stringify(this.listIdentificationType))
        },
        error: (error: HttpErrorResponse) => { this.config.handleError(error); }
      });
    else
      this.listIdentificationType = JSON.parse(localStorage.getItem('identificationType') ?? "[]")



    //this.input.nativeElement.focus();
  }


  //load cities
  loadCities = () => {
    this.localizacion.getCities(this.token.token, (this.formClient.controls.departamento.value as any).idDepartamento).subscribe({
      next: (response) => {
        this.listCities = response as Array<any>;
        // there is a selected city
        if (this.citySelected?.idCiudad > 0)
          this.formClient.controls.ciudad.setValue(this.listCities.filter(row => row.idCiudad == this.citySelected?.idCiudad)[0]);
      },
      error: (error: HttpErrorResponse) => { this.config.handleError(error); }
    })
  }

  volver = () => {
    this.router.navigate(['auth'])
  }

  searchItemClient = (string: any) => {
    window.clearTimeout(this.timeSearchCliente);
    this.timeSearchCliente = setTimeout(() => {
      this.client.getProspectiveClients(this.token.token, string.query).subscribe({
        next: (response) => {
          this.resultsLsClients = response as Array<any>;
          if (this.resultsLsClients.length == 0) {
            //this.autocomplete?.hide();
            // asignación de valores si no existe
            if (isNaN(parseInt(string.query))) {
              this.formClient.controls.nombres.setValue(string.query);
              this.formClient.controls.identificacion.reset()
            }
            else {
              this.formClient.controls.identificacion.setValue(string.query);
              this.formClient.controls.nombres.reset();
            }
          }
        },
        error: (error: HttpErrorResponse) => { this.config.handleError(error); }
      })
      window.clearTimeout(this.timeSearchCliente);
    }, 1500);


  }

  // una vez seleccionado se importa la información para mostrar en pantalla
  searchItemViewClient = (row: any) => {
    this.resultsLsClients = [];
    this.load = true;

    this.client.getClients(this.token.token, (row.value?.tipoIdentificacion ?? 1), row.value.identificacion).subscribe({
      next: (response) => {
        this.selectedClient = response as any;
        this.load = false;
        // fill form
        this.lockedFieldsIdClient = true;
        let typeIndetification: any = this.listIdentificationType.filter(row => row?.idTipoIdentificacion == this.selectedClient[0].idTipoIdentificacion)[0];
        this.formClient.controls.tipo.setValue(typeIndetification);
        this.formClient.controls.identificacion.setValue(this.selectedClient[0].identificacion);
        // verification digit calculation
        this.digito = this.config.getDigitVerification(this.selectedClient[0].identificacion.toString());

        this.formClient.controls.razonSocial.setValue(this.selectedClient[0].razonSocial);
        this.formClient.controls.nombres.setValue(this.selectedClient[0].nombres);
        this.formClient.controls.correo.setValue(this.selectedClient[0].email);
        this.formClient.controls.direccion.setValue(this.selectedClient[0].direccion);
        this.formClient.controls.telefono.setValue(this.selectedClient[0].telefono);

      },
      error: (error: HttpErrorResponse) => { this.config.handleError(error); }
    })
  }


  searchClient() {
    console.log('entroooo');

    if ((this.formClient.controls.identificacion.value ?? 0) > 0) {
      // adicionar el tipo de documento
      this.getCupo();
      this.navegar('div2', false, -30)
      this.displayInfoClient = false;
    }
    else
      this.message.add({ severity: 'warn', summary: 'Información', detail: 'Favor relacione el cliente' });
  }


  clearFormCliente = (withType?: boolean) => {
    // solo se limpian los campos identificador del cliente cuando se requiera
    if (withType ?? false) {
      this.formClient.controls.tipo.setValue(null);
      this.formClient.controls.identificacion.setValue(null);
      this.lockedFieldsIdClient = false;
    }
    this.formClient.controls.nombres.setValue('');
    this.formClient.controls.direccion.setValue('');
    this.formClient.controls.correo.setValue('');
    this.formClient.controls.telefono.setValue('');
    this.formClient.controls.razonSocial.setValue('');
    this.formClient.controls.departamento.setValue(null)
    this.formClient.controls.ciudad.setValue(null)
    this.digito = undefined;
  }

  reload = () => {
    window.location.reload();
  }
  toggle = (id: number) => {
    this.activeState[id] = true;;
  }

  validate = () => {
    if ((this.formClient.controls.nombres.value ?? '') == '') {
      this.message.add({ severity: 'warn', summary: 'Información', detail: 'El cliente no existe, debe registrarlo' })
      this.activeState = [true, false, false, false, false];
    }
    else {
      this.activeState = [false, false, false, true, false];
    }
  }

  clear = () => {
    this.formClient.reset();
    this.formAsignacion.reset();
    this.activeState = [false, false, false, false, false];
  }


  getCupo = () => {
    // en caso de que el cliente exista
    this.cartera.getCarteraGeneral(this.token.token, (this.formClient.controls.identificacion.value ?? 0), this.infoEmpresa[0].idProveedor).subscribe((response) => {
      this.lsCarteraUser = response as Array<any>;
      if (this.lsCarteraUser.length > 0) {
        this.lsCarteraUserActivo = this.lsCarteraUser.filter(row => {
          return row.idEstadoCartera == 1;
        })[0];
        //asignaciòn de valores
        this.formAsignacion.controls.valorAsignado.setValue(this.lsCarteraUserActivo.valorAsignado);
        this.formAsignacion.controls.valorConsumido.setValue(this.lsCarteraUserActivo.valorPendiente);
        this.toggle(1);

        this.detalleCartera = this.lsCarteraUserActivo.detalleCarteras.map((row: any) => {
          let sumAbono = row.detalleCarteraAbonos.map((data: any) => {
            return data.valorAplicado
          }).reduce((a: number, b: number) => b + a, 0)

          return {
            idVenta: row.idVentaPagoNavigation?.idVenta,
            fecha: row.fecha,
            valor: row.idVentaPagoNavigation?.valor - sumAbono
          }
        });

        this.abonoCarteras = this.lsCarteraUserActivo.abonoCarteras.map((row: any) => {
          return {
            fecha: row.fecha,
            metodoPago: this.metodoPagoIni.filter((item: any) => {
              return item.idVentaMetodoPago == row.idVentaMetodoPago
            })[0].label,
            valor: row.valor
          }
        });
      }
    })
  }

  saveClient = () => {
    if (this.formClient.valid) {
      this.load = true;
      const data = {
        "Identificacion": this.formClient.controls.identificacion.value,
        "Nombres": this.formClient.controls.nombres.value,
        "Email": this.formClient.controls.correo.value ?? "",
        "Telefono": this.formClient.controls.telefono.value ?? ""
      }

      this.cliente.setClient(this.token.token, data).subscribe((response: any) => {
        this.message.add({ severity: 'success', summary: 'Información', detail: 'Procesamiento exitoso' });
        this.load = false;
        this.idClienteSelected = response.idCliente;
        // validar si ya se importo el tema del cupo
        if (this.lsCarteraUser.length == 0)
          this.getCupo();
        this.navegar('div2', false, -30)
      })
    } else
      this.message.add({ severity: 'error', summary: 'Información', detail: 'Favor ingrese la información requerida' })

  }

  navegar = (enlace: string, mobile: boolean, plusPx?: number) => {
    const el: any = document.getElementById(enlace);
    window.scrollTo(0, el.offsetTop + (mobile ? el.offsetParent.offsetTop : 0) + (plusPx ?? 0));
  }

  searchNumber = (id: number) => {
    this.showTicket = true;
    let url = this.config.urlHome + "venta/recibo/" + id + "/" + this.infoParametrizacion.idComprobante;
    this.frame.nativeElement.setAttribute('src', url);
  }

  filterMetodo(event: any) {
    // el idMetodoPago = 10 hace referencia a la cartera propia
    this.metodoPagoFilter = this.metodoPagoIni.filter((row: any) => {
      return row.label.toLowerCase().indexOf(event.query) > -1 && row.idVentaMetodoPago != 10;
    });
  }

  setAbono = () => {
    // hacer perder el foco
    this.btnAbono.nativeElement.blur();
    if ((this.valorAbonoCartera > 0) && (this.selectedMethod.hasOwnProperty('idVentaMetodoPago'))) {
      this.load = true;
      const data = {
        idCartera: this.lsCarteraUserActivo.idCartera,
        idEmpleadoProveedor: this.infoUser.empleadoProveedors[0].idEmpleadoProveedor,
        idVentaMetodoPago: this.selectedMethod.idVentaMetodoPago,
        valor: this.valorAbonoCartera,
        referencia: this.referencia
      }
      this.cartera.setAbono(this.token.token, data).subscribe((response) => {
        this.message.add({ severity: 'success', summary: 'Información', detail: 'Procesamiento exitoso' });
        this.valorAbonoCartera = 0;
        this.load = false;
        this.getCupo();
      })
    }
    else
      this.message.add({ severity: 'error', summary: 'Información', detail: 'Favor ingrese la información requerida' })
  }
}
